import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { githubRepoName, githubSourceURL, } from "@gearbox-protocol/deploy-tools-shared";
import { GithubLogo, NewTab } from "./icons";
export const SourceLink = props => {
    const { source, revision, className, children } = props;
    const url = githubSourceURL({ source, revision });
    if (!url) {
        return null;
    }
    const repo = githubRepoName({ source });
    const label = revision ? `${repo}@${revision.slice(0, 7)}` : repo;
    return (_jsxs("a", { href: url, target: "_blank", className: className, rel: "noopener", title: url, children: [_jsx(GithubLogo, { size: 14, className: "inline-block mr-1 align-text-bottom" }), children ?? label, _jsx(NewTab, {})] }));
};
